import {
  acceptClientDeleteRequest,
  deleteDocument,
  editDocument,
  getClientContracts,
  getDocumentById,
  postClientContract,
  rejectContractDeleteRequest,
  sendDeleteRequestToClient,
  setClientWeddingDate,
} from './asyncThunks';

export const postClientContractBuilder = builder => {
  builder.addCase(postClientContract.pending, state => {
    state.postClientContractPending = true;
  });
  builder.addCase(postClientContract.fulfilled, (state, action) => {
    const { data } = action.payload;
    state.selectedClientContracts.data = [data, ...state.selectedClientContracts.data];
    state.postClientContractPending = false;
  });
  builder.addCase(postClientContract.rejected, state => {
    state.postClientContractPending = false;
  });
};

export const getClientContractsBuilder = builder => {
  builder
    .addCase(getClientContracts.pending, state => {
      state.fetchClientContractsPending = true;
    })
    .addCase(getClientContracts.fulfilled, (state, action) => {
      const { data } = action.payload;

      state.selectedClientContracts.data = data;
      state.fetchClientContractsPending = false;
    })
    .addCase(getClientContracts.rejected, (state, action) => {
      state.fetchClientContractsPending = false;
    });
};

export const getDocumentByIdBuilder = builder => {
  builder.addCase(getDocumentById.pending, state => {
    state.getDocumentByIdPending = true;
  });
  builder.addCase(getDocumentById.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.selectedContract = data;
    state.getDocumentByIdPending = false;
  });
  builder.addCase(getDocumentById.rejected, state => {
    state.getDocumentByIdPending = false;
  });
};

export const deleteDocumentBuilder = builder => {
  builder.addCase(deleteDocument.pending, state => {
    state.deleteDocumentPending = true;
  });
  builder.addCase(deleteDocument.fulfilled, (state, { payload }) => {
    const { id } = payload;
    state.selectedClientContracts.data = state.selectedClientContracts.data.filter(contract => contract.id !== id);

    state.deleteDocumentPending = false;
  });
  builder.addCase(deleteDocument.rejected, state => {
    state.deleteDocumentPending = false;
  });
};

export const editDocumentBuilder = builder => {
  builder.addCase(editDocument.pending, state => {
    state.editDocumentPending = true;
  });
  builder.addCase(editDocument.fulfilled, (state, { payload }) => {
    const { data, id } = payload;
    state.selectedClientContracts.data = state.selectedClientContracts.data.map(contract => {
      if (contract.id === id) {
        return { ...contract, ...data };
      }

      return contract;
    });

    state.selectedContract = { ...state.selectedContract, ...data };
    state.editDocumentPending = false;
  });
  builder.addCase(editDocument.rejected, state => {
    state.editDocumentPending = false;
  });
};

export const setClientWeddingDateBuilder = builder => {
  builder.addCase(setClientWeddingDate.pending, state => {
    state.setClientWeddingDatePending = true;
  });
  builder.addCase(setClientWeddingDate.fulfilled, (state, { payload }) => {
    state.setClientWeddingDatePending = false;
  });
  builder.addCase(setClientWeddingDate.rejected, state => {
    state.setClientWeddingDatePending = false;
  });
};

export const acceptClientDeleteRequestBuilder = builder => {
  builder.addCase(acceptClientDeleteRequest.pending, state => {
    state.acceptClientDeleteRequestPending = true;
  });
  builder.addCase(acceptClientDeleteRequest.fulfilled, (state, { payload }) => {
    state.acceptClientDeleteRequestPending = false;
  });
  builder.addCase(acceptClientDeleteRequest.rejected, state => {
    state.acceptClientDeleteRequestPending = false;
  });
};

export const sendDeleteRequestToClientBuilder = builder => {
  builder.addCase(sendDeleteRequestToClient.pending, state => {
    state.sendDeleteRequestToClientPending = true;
  });
  builder.addCase(sendDeleteRequestToClient.fulfilled, (state, { payload }) => {
    state.sendDeleteRequestToClientPending = false;
  });
  builder.addCase(sendDeleteRequestToClient.rejected, state => {
    state.sendDeleteRequestToClientPending = false;
  });
};

export const rejectContractDeleteRequestBuilder = builder => {
  builder.addCase(rejectContractDeleteRequest.pending, state => {
    state.rejectContractDeleteRequestPending = true;
  });
  builder.addCase(rejectContractDeleteRequest.fulfilled, (state, { payload }) => {
    state.rejectContractDeleteRequestPending = false;
  });
  builder.addCase(rejectContractDeleteRequest.rejected, state => {
    state.rejectContractDeleteRequestPending = false;
  });
};
